export default "__VITE_PUBLIC_ASSET__5ce49c3c__"